"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";
import QueryString from "qs";

const logisticRoutesService = {
  getLogisticRoutes: function (options) {
    return api.get(
      "/Routes",
      WithToken.headersToken(
        {
          params: options,
          paramsSerializer: (params) => {
            return QueryString.stringify(params);
          },
        },
        configuration.cookieName
      )
    );
  },
  getLogisticRoute: function (options) {
    return api.get("/Routes/" + options.id, WithToken.headersToken({ params: {} }, configuration.cookieName));
  },
  createLogisticRoute: function (options) {
    return api.post(`/Routes`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteLogisticRoute: function (options) {
    return api.delete(`/Routes`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  updateLogisticRoute: function (options) {
    return api.put("/Routes/" + options.id, options, WithToken.headersToken({}, configuration.cookieName));
  },
  addControlPointRoute: function (options) {
    return api.post(`/RouteControlPoints`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteControlPointRoute: function (options) {
    return api.delete(`/RouteControlPoints`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  setNumberControlPointRoute: function (options) {
    return api.put(
      `/RouteControlPoints`,
      {},
      WithToken.headersToken(
        {
          params: options,
          paramsSerializer: (params) => {
            return QueryString.stringify(params);
          },
        },
        configuration.cookieName
      )
    );
  },
  getLogisticRouteGeoJson: function (options) {
    return api.get("/Routes/" + options.id + "/GeoJson", WithToken.headersToken({ params: {} }, configuration.cookieName));
  },
};

export default logisticRoutesService;
